{"dirty":false,"raw":"cd07c26d6","hash":"cd07c26d6","distance":null,"tag":null,"semver":null,"suffix":"cd07c26d6","semverString":null,"version":"3.8.0"}